import React from "react";
import { useLoaderData, useParams } from "react-router-dom";
import LandingPageHeader from "./components/LandingPageHeader";

import "../src/css/LandingPage.css";

export default function LandingPage() {
  const { username, mediaId } = useParams();
  const { user, media } = useLoaderData();
  //const cleanMediaId = `urlpostMediaId#${mediaId}`;
  const caption = media?.caption?.trim();
  //const ctaText = media?.landingPageCta?.trim() || "Open link";
  //const href = media?.externalUrl;
  //Currently beacon expects the suffix (only) of the userId.
  //const beaconFriendlyUserId = user.userId.replace('userId#','');
    //console.log(`Standalone User: ${JSON.stringify(user)}`);
      // console.log(`userId ${user.userId}`)

 //const sanitizedAppThumbnailUrl = media.appThumbnailUrl.replace("d3kk23yp7yofqk.cloudfront.net", "www-dev.gotolinks.com");
 //let sanitizedAppThumbnailUrl = media.appOriginalUrl.replace("d3kk23yp7yofqk.cloudfront.net", "www-dev.gotolinks.com");
 //sanitizedAppThumbnailUrl = sanitizedAppThumbnailUrl.replace("closing-chipmunk-positively.ngrok-free.app", "www-dev.gotolinks.com");

 const APP_DOMAIN = `https://${process.env.REACT_APP_DOMAIN}`;
    const sanitizedAppThumbnailUrl = media.appOriginalUrl.replace(
    /^https:\/\/[^/]+/,
    APP_DOMAIN
  );

    //console.log(media.appOriginalUrl);
    //console.log(sanitizedAppThumbnailUrl);
    //console.log(imageUrl);


  return (
    <>
      <LandingPageHeader user={user} media={media} />
      <main className="standalone-page">
       <section className="standalone-card" aria-label="Standalone media item">
          {media?.appThumbnailUrl ? (
            <img
              className="standalone-img"
              src={sanitizedAppThumbnailUrl}
              alt={caption || `Media item`}
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="standalone-img-placeholder">
              Image unavailable
            </div>
          )}

          {caption ? (
            <p className="standalone-caption">{caption}</p>
          ) : null}


        </section>
      </main>
    </>
  );
}
